import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Postulante } from 'src/app/project/interfaces/postulante';
import { PostulantesService } from 'src/app/project/services/postulantes.service';
import { SessionService } from 'src/app/project/services/session.service';
import { RegionUtils } from 'src/app/project/tools/utils/region.utils';

@Component({
  selector: 'app-datos-personales',
  templateUrl: './datos-personales.component.html',
  styleUrls: ['./datos-personales.component.css']
})
export class DatosPersonalesComponent implements OnInit {

  loading: boolean = true;
  readonly: boolean = true;
  isEditing: boolean = false;
  isSaving: boolean = false;
  public formContacto: FormGroup;
  public postulante: Postulante;
  public regiones: any[];
  public comunas: any[] = [];

  constructor(
    private postulantesService: PostulantesService,
    private regionUtils: RegionUtils,
    private messageService: MessageService
  ) { 
    this.postulantesService.consultarDatos().then( (postulante: Postulante) => {
      
      this.postulante = postulante
      
      this.regionUtils.getAsyncRegionesDropdown().then(regiones => {
      
        this.regiones = regiones;
      
        this.regionUtils.getAsyncComunasDropdown(this.postulante.id_region).then(comunas => {
      
          this.comunas = comunas;   
      
          this.formContacto = new FormGroup({
            telefono: new FormControl(this.postulante.telefono, [Validators.min(0), Validators.minLength(9), Validators.maxLength(9), Validators.pattern(/^([0-9])*$/)]),
            direccion: new FormControl(this.postulante.direccion, [Validators.maxLength(100)]),
            id_region: new FormControl(this.postulante.id_region, [Validators.required]),
            id_provincia: new FormControl(null, []),
            id_comuna: new FormControl(this.postulante.id_comuna, [Validators.required]),
            ocupacion: new FormControl(this.postulante.ocupacion, [Validators.required, Validators.maxLength(250)]),
            empresa: new FormControl(this.postulante.empresa, [Validators.maxLength(150)])
          });

          setTimeout(() => {
            this.loading = false
          }, 500);
        })   
      });
    })
        
  }

  regExpInput(pattern, event) {
    const maskSeperator = new RegExp(pattern, 'g');
    let result = maskSeperator.test(event.key); return result;
  } 

  setEditing(){
    this.readonly = false;
    this.isEditing = true;
  }

  cancelEditing(){
    this.regionUtils.getAsyncComunasDropdown(this.postulante.id_region).then(comunas => {
      this.comunas = comunas;   
    })  
    this.formContacto.get('telefono').setValue(this.postulante.telefono);
    this.formContacto.get('direccion').setValue(this.postulante.direccion);
    this.formContacto.get('id_region').setValue(this.postulante.id_region);
    this.formContacto.get('id_comuna').setValue(this.postulante.id_comuna);
    this.formContacto.get('ocupacion').setValue(this.postulante.ocupacion);
    this.formContacto.get('empresa').setValue(this.postulante.empresa);
    this.readonly = true;
    this.isEditing = false;
  }

  saveEditing(){
    this.readonly = true;
    this.isSaving = true;
    this.postulantesService.actualizarDatosContacto(this.formContacto.value).then(res => {
      this.messageService.add({ severity: 'success', summary: 'Cambios guardados', detail: 'Su información ha sido modificada con éxito.' });    
      this.isEditing = false; 
      this.isSaving = false;
    });
  }

  cargarComunas() {
    this.comunas = this.regionUtils.getComunasRegionDropdown(this.formContacto.get('id_region').value);
    this.formContacto.get('id_comuna').setValue(null);
  }

  ngOnInit(): void {

  }

  onSubmit(){
    
  }

}
